import { InlineLoader } from '@dealstack/frontend/shared/components/loaders/InlineLoader/InlineLoader.tsx';
import { ROUTES } from '@dealstack/frontend/app/pages/Routing/routes.ts';
import { DealCards } from '@dealstack/frontend/app/pages/Dashboard/DealCards.tsx';
import { generatePath, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getUserDealList } from '@dealstack/frontend/shared/dataExchange/services/project.service.ts';
import { DateTime } from 'luxon';
import { EmptyDashboard } from '@dealstack/frontend/app/pages/Dashboard/EmptyDashboard.tsx';
import { useAppSelector } from '@dealstack/frontend/app/hooks/redux.ts';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';

export const DashboardDeals = () => {
	const navigate = useNavigate();
	const userState = useAppSelector((state) => state.user);

	const getDealListRequest = useQuery({
		queryKey: [API_PATHS.DEAL_GET, userState.data],
		queryFn: ({ signal }) => getUserDealList(signal),
		enabled: !!userState.data,
		refetchOnReconnect: true,
		refetchIntervalInBackground: true,
		refetchInterval: 60000,
		select: (data) =>
			data.payload?.sort((a, b) => {
				const dateA = DateTime.fromISO(a.updatedAt);
				const dateB = DateTime.fromISO(b.updatedAt);
				return dateA > dateB ? -1 : 1;
			}),
	});

	const deals = getDealListRequest?.data;
	return (
		<>
			{getDealListRequest?.isFetching && <InlineLoader />}
			{!getDealListRequest?.isFetching && !deals?.length && (
				<EmptyDashboard onAdd={() => navigate(ROUTES.DEAL_CREATE)} />
			)}
			{!getDealListRequest?.isFetching && deals && deals.length > 0 && (
				<DealCards
					deals={deals}
					getDealLink={(dealId) => generatePath(ROUTES.DEAL, { dealId })}
				/>
			)}
		</>
	);
};
